'use client';

interface IconButtonProps {
  icon: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  color: string;
  size: string;
  leading?: string;
  className?: string;
}

const IconButton = ({ icon, onClick, onMouseEnter, onMouseLeave, color, size, leading, className }: IconButtonProps) => {
  return (
    <button type="button" className={`flex justify-center items-center ${className}`} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <i className={`${icon} ${color} ${size} ${leading}`} />
    </button>
  );
};

export default IconButton;
